<template>
  <div>
    <v-form ref="form">
      <v-toolbar dense color="white" v-if="isWeb">
        <v-toolbar-title>管理車両{{ saveTitleText }}</v-toolbar-title>
      </v-toolbar>
      <v-container fluid v-if="isWeb">
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p v-show="editFlag" style="margin: 5px 0 15px 0" v-if="!readOnly">
          管理車両情報は上段で編集し、更新ボタンを押下して更新してください。
        </p>
        <p style="margin: 5px 0 15px 0" v-if="!readOnly">
          自衛隊車両、外交官車両などの特殊車両の場合は、「特殊車両」をチェックし、入力時に表示される例に従って車番を入力してください。
        </p>
        <v-row>
          <v-col cols="4" sm="3" md="2" lg="2">
            <v-btn
              class="mx-2"
              color="primary"
              @click="companyListDialog = true"
              >車両事業者{{ carOperatorButtonTitle }}</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="4">
            <v-autocomplete
              v-model="submitItem.carop_id"
              :items="companiesSelect"
              item-text="carop_name"
              item-value="carop_id"
              :rules="[rules.required]"
              label="車両事業者：営業所（文字入力で絞り込み可）"
              placeholder="選択してください"
              @change="checkSubmit()"
              clearable
              v-bind="formControlProps()"
            >
              <template slot="item" slot-scope="data">
                <!-- Divider and Header-->
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item" />
                </template>
                <!-- Normal item -->
                <template v-else>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.carop_name" />
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
            <v-dialog
              v-model="companyListDialog"
              :nudge-width="400"
              transition="fade-transition"
              scrollable
              persistent
            >
              <v-card>
                <v-card-title> 車両事業者一覧 </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6" md="6" lg="6">
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        placeholder="車両事業者名または営業所名を入力すると絞り込めます"
                        maxlength="30"
                        single-line
                        hide-details
                        outlined
                        clearable
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6">
                      <div class="text-right">
                        <v-btn
                          class="mx-2"
                          color="primary"
                          @click="addCompany()"
                          v-if="!readOnly"
                        >
                          「新規登録」はこのボタンを押してください
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                  <v-data-table
                    :headers="companiesHeaders"
                    :items="companies"
                    :search="search"
                    :hide-default-footer="true"
                    class="elevation-1"
                    locale="ja-jp"
                    height="250px"
                    disable-pagination
                    must-sort
                  >
                    <template v-slot:[`item.actions`]="{ item }">
                      <div>
                        <v-btn
                          small
                          class="mx-2 ma-2"
                          color="primary"
                          @click.stop="editCompanyItem(item)"
                        >
                          {{ $editButtonText(readOnly) }}
                        </v-btn>
                        <v-btn
                          small
                          class="mx-2 ma-2"
                          color="primary"
                          @click.stop="deleteCompanyConfirm(item)"
                          v-if="!readOnly"
                        >
                          削除
                        </v-btn>
                      </div>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="companyListDialog = false">
                    戻る
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="4">
            <v-text-field
              v-model="submitItem.car_type_disp"
              label="車両種別（種別／種類／大きさ）"
              placeholder="選択してください"
              :readonly="true"
              :rules="[rules.required]"
              @click="cartypeSelectDialog = true"
              @click:clear="carTypeClear()"
              @change="checkSubmit()"
              clearable
              v-bind="formControlProps()"
            >
            </v-text-field>
            <v-dialog
              v-model="cartypeSelectDialog"
              scrollable
              width="50%"
              persistent
            >
              <v-card>
                <v-card-title>車両種別選択</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 450px">
                  <v-row>
                    <v-col>
                      <v-treeview
                        :items="cartypeTree"
                        item-key="id"
                        open-on-click
                        color="warning"
                        transition
                      >
                        <template slot="label" slot-scope="{ item }">
                          <div v-if="item.children">
                            {{ item.name }}
                          </div>
                          <div
                            v-if="!item.children"
                            @click="
                              selectCartype(item.code), specialCarResponse()
                            "
                          >
                            {{ item.name }}
                          </div>
                        </template>
                      </v-treeview>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="cartypeSelectDialog = false">
                    キャンセル
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="4">
            <v-text-field
              v-model="submitItem.car_limit"
              :rules="[rules.required]"
              label="定員"
              type="number"
              placeholder="入力してください"
              @change="checkSubmit()"
              min="1"
              max="99"
              oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;if(Number(this.value) < Number(this.min)) this.value = this.min;"
              clearable
              v-bind="formControlProps(2)"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-row style="margin-top: -12px">
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-checkbox
                  v-model="specialFlag"
                  label="特殊車両"
                  @click="specialFlagResponse()"
                  v-bind="formControlProps()"
                >
                </v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" md="8" lg="9" v-if="specialFlag">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="submitItem.car_number.special"
                      :rules="[rules.required]"
                      label="車番"
                      placeholder="入力してください"
                      maxlength="15"
                      @change="checkSubmit()"
                      clearable
                      v-bind="formControlProps(15)"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <p>
                    特殊車両の種類に応じて、以下の形式で車番を入力してください。<br />
                    （数字、ハイフンについては半角入力）
                  </p>
                  <table>
                    <tr>
                      <td>自衛隊車両：</td>
                      <td style="padding-left: 1em;">12-3456</td>
                    </tr>
                    <tr>
                      <td>外交官車両：</td>
                      <td style="padding-left: 1em;">外-1234</td>
                    </tr>
                    <tr>
                      <td>領事館車両：</td>
                      <td style="padding-left: 1em;">領-1234</td>
                    </tr>
                  </table>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3" v-if="!specialFlag">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="submitItem.car_number.area"
                      :rules="[rules.required, rules.zenkaku]"
                      label="車番"
                      placeholder="鹿児島"
                      maxlength="4"
                      @change="checkSubmit()"
                      clearable
                      v-bind="formControlProps(4)"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <p>
                    以下の形式で車番を入力してください。<br />
                    （ハイフン、点抜きで、英数字は半角入力）
                  </p>
                  <table>
                    <tr>
                      <td>数字4桁（ 12 - 34 ）：</td>
                      <td style="padding-left: 1em;">鹿児島 200 あ 1234</td>
                    </tr>
                    <tr>
                      <td>数字1桁（・・・1）：</td>
                      <td style="padding-left: 1em;">鹿児島 200 い 1</td>
                    </tr>
                    <tr>
                      <td>アルファベット（ 20A ）：</td>
                      <td style="padding-left: 1em;">鹿児島 20A う 1234</td>
                    </tr>
                  </table>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="2" v-if="!specialFlag">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="submitItem.car_number.class"
                      :rules="[rules.required, rules.alphaNum]"
                      placeholder="200"
                      maxlength="3"
                      @change="checkSubmit()"
                      clearable
                      v-bind="formControlProps(3)"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <p>
                    以下の形式で車番を入力してください。<br />
                    （ハイフン、点抜きで、英数字は半角入力）
                  </p>
                  <table>
                    <tr>
                      <td>数字4桁（ 12 - 34 ）：</td>
                      <td style="padding-left: 1em;">鹿児島 200 あ 1234</td>
                    </tr>
                    <tr>
                      <td>数字1桁（・・・1）：</td>
                      <td style="padding-left: 1em;">鹿児島 200 い 1</td>
                    </tr>
                    <tr>
                      <td>アルファベット（ 20A ）：</td>
                      <td style="padding-left: 1em;">鹿児島 20A う 1234</td>
                    </tr>
                  </table>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="2" v-if="!specialFlag">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="submitItem.car_number.kind"
                      :rules="[rules.required, rules.hiraganaOrAlpha]"
                      placeholder="あ"
                      maxlength="1"
                      @change="checkSubmit()"
                      clearable
                      v-bind="formControlProps(1)"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <p>
                    以下の形式で車番を入力してください。<br />
                    （ハイフン、点抜きで、英数字は半角入力）
                  </p>
                  <table>
                    <tr>
                      <td>数字4桁（ 12 - 34 ）：</td>
                      <td style="padding-left: 1em;">鹿児島 200 あ 1234</td>
                    </tr>
                    <tr>
                      <td>数字1桁（・・・1）：</td>
                      <td style="padding-left: 1em;">鹿児島 200 い 1</td>
                    </tr>
                    <tr>
                      <td>アルファベット（ 20A ）：</td>
                      <td style="padding-left: 1em;">鹿児島 20A う 1234</td>
                    </tr>
                  </table>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="2" v-if="!specialFlag">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="submitItem.car_number.number"
                      :rules="[rules.required]"
                      placeholder="1234"
                      type="number"
                      min="1"
                      max="9999"
                      oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;if(Number(this.value) < Number(this.min)) this.value = this.min;"
                      @change="checkSubmit()"
                      clearable
                      v-bind="formControlProps(4)"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <p>
                    以下の形式で車番を入力してください。<br />
                    （ハイフン、点抜きで、英数字は半角入力）
                  </p>
                  <table>
                    <tr>
                      <td>数字4桁（ 12 - 34 ）：</td>
                      <td style="padding-left: 1em;">鹿児島 200 あ 1234</td>
                    </tr>
                    <tr>
                      <td>数字1桁（・・・1）：</td>
                      <td style="padding-left: 1em;">鹿児島 200 い 1</td>
                    </tr>
                    <tr>
                      <td>アルファベット（ 20A ）：</td>
                      <td style="padding-left: 1em;">鹿児島 20A う 1234</td>
                    </tr>
                  </table>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="4" v-show="editFlag">
            <v-text-field v-model="carStatus" label="車両状態" disabled>
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid v-if="!isWeb">
        <error-message :error-object="errorObject" />
      </v-container>
      <div class="text-right" v-if="isWeb">
        <v-btn
          color="primary"
          @click="confirm"
          :disabled="validationFlag"
          v-if="!readOnly"
        >
          {{ saveBtnText }}
        </v-btn>
        <v-btn class="mx-2 ma-2" color="primary" @click="close">
          {{ $cancelButtonText(readOnly) }}
        </v-btn>
      </div>
      <v-divider v-show="editFlag" class="mb-3" v-if="isWeb"></v-divider>
    </v-form>
    <div v-show="editFlag">
      <p style="margin: 5px 0 15px 0" v-if="!readOnly">
        当該車両の搭載資機材情報は下の表で編集してください。変更は即時に反映されます。
      </p>

      <v-toolbar dense color="white">
        <v-toolbar-title>搭載資機材</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="equipmentDialog" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2"
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="addEquipment()"
              v-if="!readOnly && isWeb"
            >
              「新規登録」はこのボタンを押してください
            </v-btn>
            <v-btn
              class="mx-2"
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="addEquipment()"
              v-if="!isWeb"
            >
              新規登録
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline"
                >搭載資機材{{ saveTitleTextEquipment }}</span
              >
            </v-card-title>
            <v-card-text>
              <v-form ref="addEquipmentForm">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-tooltip bottom v-if="equipmentItem.equipment_cls">
                        <template v-slot:activator="{ on }">
                          <span v-on="on">
                            <v-text-field
                              v-model="equipmentItem.equipment_cls"
                              label="事業区分"
                              placeholder="資機材の選択で自動的に入力されます"
                              disabled
                            >
                            </v-text-field>
                          </span>
                        </template>
                        <span>{{ equipmentItem.equipment_cls }}</span>
                      </v-tooltip>
                      <v-text-field
                        v-if="!equipmentItem.equipment_cls"
                        v-model="equipmentItem.equipment_cls"
                        label="事業区分"
                        placeholder="資機材の選択で自動的に入力されます"
                        disabled
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-tooltip bottom v-if="equipmentItem.equipment_kind">
                        <template v-slot:activator="{ on }">
                          <span v-on="on">
                            <v-text-field
                              v-model="equipmentItem.equipment_kind"
                              label="分類"
                              placeholder="資機材の選択で自動的に入力されます"
                              disabled
                            >
                            </v-text-field>
                          </span>
                        </template>
                        <span>{{ equipmentItem.equipment_kind }}</span>
                      </v-tooltip>
                      <v-text-field
                        v-if="!equipmentItem.equipment_kind"
                        v-model="equipmentItem.equipment_kind"
                        label="分類"
                        placeholder="資機材の選択で自動的に入力されます"
                        disabled
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-tooltip bottom v-if="equipmentItem.equipment_name">
                        <template v-slot:activator="{ on }">
                          <span v-on="on">
                            <v-text-field
                              v-model="equipmentItem.equipment_name"
                              label="資機材"
                              placeholder="資機材を選択してください"
                              :readonly="true"
                              :disabled="!isNewEquipment"
                              :rules="[rules.required]"
                              @click="equipmentSelectDialog = true"
                              @click:clear="
                                equipmentItem.equipment_kind = '';
                                equipmentItem.equipment_cls = '';
                              "
                              @change="checkEquipmentSubmit()"
                              :outlined="isNewEquipment"
                              clearable
                            >
                            </v-text-field>
                          </span>
                        </template>
                        <span>{{ equipmentItem.equipment_name }}</span>
                      </v-tooltip>
                      <v-text-field
                        v-if="!equipmentItem.equipment_name"
                        v-model="equipmentItem.equipment_name"
                        label="資機材"
                        placeholder="資機材を選択してください"
                        :readonly="true"
                        :disabled="!isNewEquipment"
                        :rules="[rules.required]"
                        @click="equipmentSelectDialog = true"
                        @click:clear="
                          equipmentItem.equipment_kind = '';
                          equipmentItem.equipment_cls = '';
                        "
                        @change="checkEquipmentSubmit()"
                        :outlined="isNewEquipment"
                        clearable
                      >
                      </v-text-field>
                      <v-dialog
                        v-model="equipmentSelectDialog"
                        scrollable
                        width="70%"
                        persistent
                      >
                        <v-card>
                          <v-card-title>資機材選択</v-card-title>
                          <v-divider></v-divider>
                          <v-card-text style="height: 450px">
                            <v-row>
                              <v-col>
                                <v-col>
                                  <v-row align="center">
                                    <v-flex xs12 sm3 md2>
                                      <input
                                        type="radio"
                                        v-model="radioValue"
                                        :value="true"
                                      />全て
                                    </v-flex>
                                    <v-flex xs12 sm3 md2>
                                      <input
                                        type="radio"
                                        v-model="radioValue"
                                        :value="false"
                                      />車両搭載対象のみ
                                    </v-flex>
                                    <v-flex>
                                      <v-dialog
                                        v-model="selectionEquipment"
                                        scrollable
                                        width="68%"
                                        persistent
                                      >
                                        <template #activator="{ on }">
                                          <v-btn v-on="on" color="primary"
                                            >車両搭載対象選択</v-btn
                                          >
                                        </template>
                                        <v-card>
                                          <v-card-title>
                                            車両搭載対象選択
                                          </v-card-title>
                                          <v-divider></v-divider>
                                          <v-card-text style="height: 450px;">
                                            <v-treeview
                                              v-model="selection"
                                              :items="equipments"
                                              selectable
                                              return-object
                                            >
                                            </v-treeview>
                                          </v-card-text>
                                          <v-divider></v-divider>
                                          <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                              color="primary"
                                              @click="
                                                selectEquipmentConfirmDialog = true
                                              "
                                            >
                                              登録
                                            </v-btn>
                                            <!-- 登録処理の確認ダイアログを表示する -->
                                            <v-btn
                                              color="primary"
                                              @click.stop="saveConfirm()"
                                            >
                                              キャンセル
                                            </v-btn>
                                          </v-card-actions>
                                        </v-card>
                                      </v-dialog>
                                      <v-dialog
                                        v-model="saveDialog"
                                        persistent
                                        max-width="400"
                                      >
                                        <v-card>
                                          <v-card-title></v-card-title>
                                          <v-card-text>
                                            <p>
                                              現在選択されている資機材は、<br />
                                              まだ車両搭載対象として登録されていません。<br />
                                              登録しますか？
                                            </p>
                                          </v-card-text>

                                          <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                              color="primary"
                                              @click="
                                                saveDialog = false;
                                                selectEquipmentConfirmDialog = true;
                                              "
                                            >
                                              登録する
                                            </v-btn>
                                            <v-btn
                                              color="primary"
                                              @click="
                                                saveDialog = false;
                                                selectionEquipment = false;
                                              "
                                            >
                                              登録しない
                                            </v-btn>
                                          </v-card-actions>
                                        </v-card>
                                      </v-dialog>
                                    </v-flex>
                                  </v-row>
                                </v-col>
                                <v-treeview
                                  v-if="radioValue"
                                  :items="equipments"
                                  item-key="id"
                                  :search="search"
                                  item-disabled="locked"
                                  open-on-click
                                  color="warning"
                                  transition
                                >
                                  <template slot="label" slot-scope="{ item }">
                                    <div v-if="item.children">
                                      <span
                                        class="d-inline-block text-truncate"
                                        style="max-width: 100%"
                                      >
                                        {{ item.name }}
                                      </span>
                                    </div>
                                    <div
                                      v-if="!item.children && !item.locked"
                                      @click="selectEquipment(item)"
                                    >
                                      <span
                                        class="d-inline-block text-truncate"
                                        style="max-width: 100%"
                                      >
                                        {{ item.name }}
                                      </span>
                                    </div>
                                    <div v-if="!item.children && item.locked">
                                      <span
                                        class="d-inline-block text-truncate"
                                        style="max-width: 100%"
                                      >
                                        {{ item.name }}
                                      </span>
                                    </div>
                                  </template>
                                </v-treeview>
                                <v-treeview
                                  v-else
                                  :items="selectedEquipments"
                                  item-key="id"
                                  :search="search"
                                  item-disabled="locked"
                                  open-on-click
                                  color="warning"
                                  transition
                                >
                                  <template slot="label" slot-scope="{ item }">
                                    <div v-if="item.children">
                                      <span
                                        class="d-inline-block text-truncate"
                                        style="max-width: 100%"
                                      >
                                        {{ item.name }}
                                      </span>
                                    </div>
                                    <div
                                      v-if="!item.children && !item.locked"
                                      @click="selectEquipment(item)"
                                    >
                                      <span
                                        class="d-inline-block text-truncate"
                                        style="max-width: 100%"
                                      >
                                        {{ item.name }}
                                      </span>
                                    </div>
                                    <div v-if="!item.children && item.locked">
                                      <span
                                        class="d-inline-block text-truncate"
                                        style="max-width: 100%"
                                      >
                                        {{ item.name }}
                                      </span>
                                    </div>
                                  </template>
                                </v-treeview>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="primary"
                              @click="equipmentSelectDialog = false"
                            >
                              キャンセル
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="10" sm="5" md="3" lg="3">
                      <v-text-field
                        v-model="equipmentItem.equipment_quantity"
                        label="個数"
                        placeholder="入力してください"
                        type="number"
                        min="1"
                        max="999"
                        :rules="[rules.required]"
                        oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;if(Number(this.value) < Number(this.min)) this.value = this.min;"
                        @change="checkEquipmentSubmit()"
                        outlined
                        clearable
                        counter="3"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="equipmentConfirmDialog = true"
                :disabled="equipmentValidationFlag"
              >
                {{ saveBtnTextEquipment }}
              </v-btn>
              <v-btn color="primary" @click="equipmentDialog = false">
                {{ $cancelButtonText(readOnly) }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <top-operation-data-table
        disp-mode="nowrap"
        :headers="equipmentHeaders"
        :items="mountEquipmentList"
        :sort-by="['equipment_cls', 'equipment_kind', 'equipment_id']"
        :sort-desc="[false, false, false]"
        class="fixedWidth"
        locale="ja-jp"
        must-sort
        v-if="isWeb"
      >
        <template v-slot:[`item.equipment_cls`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="d-inline-block text-truncate"
                style="max-width: 720px"
              >
                {{ item.equipment_cls }}
              </span>
            </template>
            <span>{{ item.equipment_cls }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.equipment_kind`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="d-inline-block text-truncate"
                style="max-width: 720px"
              >
                {{ item.equipment_kind }}
              </span>
            </template>
            <span>{{ item.equipment_kind }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.equipment_name`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="d-inline-block text-truncate"
                style="max-width: 720px"
              >
                {{ item.equipment_name }}
              </span>
            </template>
            <span>{{ item.equipment_name }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div>
            <v-btn
              small
              class="mx-2 ma-2"
              color="primary"
              @click.stop="editEquipment(item)"
            >
              編集
            </v-btn>
            <v-btn
              small
              class="mx-2 ma-2"
              color="primary"
              @click.stop="deleteEquipmentConfirm(item)"
            >
              削除
            </v-btn>
          </div>
        </template>
      </top-operation-data-table>
      <top-operation-data-table
        :headers="equipmentHeaders"
        :items="mountEquipmentList"
        :sort-by="['equipment_cls', 'equipment_kind', 'equipment_id']"
        :sort-desc="[false, false, false]"
        locale="ja-jp"
        must-sort
        mobile-breakpoint="0"
        v-if="!isWeb"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <div>
            <v-btn
              small
              class="mx-2 ma-2"
              color="primary"
              @click.stop="editEquipment(item)"
            >
              編集
            </v-btn>
            <v-btn
              small
              class="mx-2 ma-2"
              color="primary"
              @click.stop="deleteEquipmentConfirm(item)"
            >
              削除
            </v-btn>
          </div>
        </template>
      </top-operation-data-table>
    </div>

    <v-dialog v-model="comfirmDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ saveBtnText }}確認</v-card-title>
        <v-card-text> {{ saveBtnText }}してもよろしいですか？ </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="submit" :disabled="processingFlag">
            {{ saveBtnText }}
          </v-btn>
          <v-btn
            color="primary"
            @click="comfirmDialog = false"
            :disabled="processingFlag"
          >
            キャンセル
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="equipmentConfirmDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline"
          >{{ saveBtnTextEquipment }}確認</v-card-title
        >
        <v-card-text>
          {{ saveBtnTextEquipment }}してもよろしいですか？
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="saveEquipment()"
            :disabled="processingFlag"
          >
            {{ saveBtnTextEquipment }}
          </v-btn>
          <v-btn
            color="primary"
            @click="equipmentConfirmDialog = false"
            :disabled="processingFlag"
          >
            キャンセル
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteEquipmentDialog" persistent max-width="400">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text
          >資機材名「{{
            deleteEquipmentName
          }}」の搭載資機材を削除してもよろしいですか？</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="deleteEquipment(deleteEquipmentIndex)"
            :disabled="processingFlag"
          >
            削除
          </v-btn>
          <v-btn
            color="primary"
            @click="deleteEquipmentDialog = false"
            :disabled="processingFlag"
          >
            キャンセル
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="selectEquipmentConfirmDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">登録確認</v-card-title>
        <v-card-text>
          登録してもよろしいですか？
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="saveSelectedEquipment()"
            :disabled="processingFlag"
          >
            登録
          </v-btn>
          <v-btn
            color="primary"
            @click="selectEquipmentConfirmDialog = false"
            :disabled="processingFlag"
          >
            キャンセル
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="companyDialog" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">車両事業者{{ saveTitleTextCompany }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="companyForm">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-text-field
                    v-model="companyItem.company_name"
                    label="車両事業者名"
                    placeholder="入力してください"
                    maxlength="30"
                    :rules="[rules.required, rules.exceptColon]"
                    @change="checkCompanySubmit()"
                    clearable
                    v-bind="formControlProps(30)"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-text-field
                    v-model="companyItem.sales_office_name"
                    label="営業所名"
                    placeholder="入力してください"
                    maxlength="30"
                    :rules="[rules.exceptColon]"
                    @change="checkCompanySubmit()"
                    clearable
                    v-bind="formControlProps(30)"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-select
                    :items="caropClses"
                    v-model="companyItem.carop_cls"
                    label="車両事業者区分"
                    placeholder="選択してください"
                    :rules="[rules.required]"
                    @change="checkCompanySubmit()"
                    v-bind="formControlProps()"
                    clearable
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-text-field
                    v-model="companyItem.tel_no"
                    label="代表電話番号"
                    placeholder="入力してください"
                    maxlength="20"
                    :rules="[rules.telNo]"
                    @change="checkCompanySubmit()"
                    clearable
                    v-bind="formControlProps(20)"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-text-field
                    v-model="companyItem.mail_address"
                    label="メールアドレス"
                    placeholder="入力してください"
                    maxlength="100"
                    :rules="[rules.mailAddress]"
                    @change="checkCompanySubmit()"
                    clearable
                    v-bind="formControlProps(100)"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="companyConfirmDialog = true"
            :disabled="companyValidationFlag"
            v-if="!readOnly"
          >
            {{ saveBtnTextCompany }}
          </v-btn>
          <v-btn color="primary" @click="companyDialog = false">
            {{ $cancelButtonText(readOnly) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="companyConfirmDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline"
          >{{ saveBtnTextCompany }}確認</v-card-title
        >
        <v-card-text>
          {{ saveBtnTextCompany }}してもよろしいですか？
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="saveCompany()"
            :disabled="processingFlag"
          >
            {{ saveBtnTextCompany }}
          </v-btn>
          <v-btn
            color="primary"
            @click="companyConfirmDialog = false"
            :disabled="processingFlag"
          >
            キャンセル
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteCompanyDialog" persistent max-width="400">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text
          >車両事業者：営業所「{{
            deleteCompanyName
          }}」の車両事業者を削除してもよろしいですか？</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="deleteCompany(deleteCompanyIndex)"
            :disabled="processingFlag"
          >
            削除
          </v-btn>
          <v-btn
            color="primary"
            @click="deleteCompanyDialog = false"
            :disabled="processingFlag"
          >
            キャンセル
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import Vue from "vue";
import ScreenAuthority from "@/plugins/screen-authority";
import { ScreenId } from "@/js/value-objects/screen-id";
import messageUtils from "@/mixins/message-utils";
import FormUtils from "@/plugins/form-utils";
Vue.use(ScreenAuthority);
Vue.use(FormUtils);

export default {
  mixins: [messageUtils],
  components: {
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },
  data: () => ({
    readOnly: true,
    isWeb: true,
    overlay: false,
    editedIndex: -1,
    editFlag: true,
    validationFlag: true,
    search: "",
    selectCompanyClick: false,
    companyListDialog: false,
    processingFlag: false,

    equipmentValidationFlag: false,
    equipmentDialog: false,
    equipmentConfirmDialog: false,
    deleteEquipmentDialog: false,
    deleteEquipmentIndex: -1,
    deleteEquipmentName: null,
    isNewEquipment: true,
    editEquipmentIndex: -1,
    equipmentItemDefault: {
      equipment_man_id: -1,
      equipment_id: -1,
      equipment_name: "",
      equipment_kind_id: -1,
      equipment_kind: "",
      equipment_quantity: "",
      modified_hash: ""
    },
    equipmentItem: {
      equipment_man_id: 0,
      equipment_id: 21,
      equipment_name: "救護所設置用具",
      equipment_kind_id: 1,
      equipment_kind: "除染用資機材",
      equipment_quantity: 5,
      modified_hash: "1234567890"
    },
    cartypeSelectDialog: false,

    equipmentSelectDialog: false,

    companyValidationFlag: false,
    companyDialog: false,
    companyConfirmDialog: false,
    deleteCompanyDialog: false,
    deleteCompanyName: null,
    deleteCompanyIndex: -1,
    isNewCompany: true,
    editCompanyIndex: -1,
    companyItemDefalut: {
      carop_id: -1,
      carop_name: "",
      company_name: "",
      sales_office_name: "",
      tel_no: "",
      carop_cls: "",
      mail_address: "",
      modified_hash: ""
    },
    companyItem: {
      carop_id: -1,
      carop_name: "",
      company_name: "",
      sales_office_name: "",
      tel_no: "",
      carop_cls: "",
      mail_address: "",
      modified_hash: "1234567890"
    },

    comfirmDialog: false,

    rules: {
      required: value => !!value || "必須項目です。",
      selectRequired: value => value.length !== 0 || "必須項目です。",
      zenkaku: value => {
        const pattern = /^[^!-~｡-ﾟ]+$/;
        return pattern.test(value) || "全角文字で入力してください。";
      },
      alphaNum: value => {
        const pattern = /^[A-Za-z0-9]+$/;
        return pattern.test(value) || "半角英数字で入力してください。";
      },
      hiraganaOrAlpha: value => {
        const hiraganaPattern = /^[ぁ-んー]+$/;
        const alphaPattern = /^[A-Za-z]+$/;
        return (
          hiraganaPattern.test(value) ||
          alphaPattern.test(value) ||
          "ひらがなまたは半角英字で入力してください。"
        );
      },
      telNo: value => {
        const pattern = /^[0-9()-]*$/;
        return (
          pattern.test(value) ||
          value == "" ||
          value == null ||
          "半角の数字、ハイフン「-」、まるかっこ「()」の組み合わせで入力してください。"
        );
      },
      mailAddress: value => {
        const pattern = /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        return (
          pattern.test(value) ||
          value == "" ||
          value == null ||
          "「@(アットマーク)」を含んだ正しいメールアドレスの形式で入力してください。"
        );
      },
      exceptColon: value =>
        !value || !value.includes("：") || "全角コロン「：」は入力できません。"
    },

    submitItem: {
      car_id: "",
      carop_id: "",
      car_type: "",
      car_type_disp: "",
      car_limit: "",
      car_number: { area: "", class: "", kind: "", number: "", special: "" },
      modified_hash: ""
    },

    registerItem: {
      car_type: ""
    },

    mountEquipmentList: [],
    equipmentList: [],
    carMountEquipmentIdList: [],
    carMountModifiedHash: "",
    companies: [],
    carStatus: "",
    carStatusList: [
      {
        value: "6",
        text: "配車待ち"
      },
      {
        value: "8",
        text: "配車中"
      },
      {
        value: "9",
        text: "避難中"
      },
      {
        value: "10",
        text: "避難完了"
      }
    ],
    specialFlag: false,

    selection: [],

    selectionEquipment: false,

    radioValue: true,

    saveDialog: false,
    selectEquipmentConfirmDialog: false
  }),

  computed: {
    cartypeTree() {
      return [
        {
          id: 1,
          name: "バス",
          children: [
            {
              id: 1_1,
              name: "乗合",
              children: [
                { id: 1_1_1, name: "大型", code: "8" },
                { id: 1_1_2, name: "中型", code: "9" },
                { id: 1_1_3, name: "小型", code: "10" }
              ]
            },
            {
              id: 1_2,
              name: "貸切",
              children: [
                { id: 1_2_1, name: "大型", code: "11" },
                { id: 1_2_2, name: "中型", code: "21" },
                { id: 1_2_3, name: "小型", code: "22" }
              ]
            },
            {
              id: 1_3,
              name: "高速",
              children: [
                { id: 1_3_1, name: "大型", code: "12" },
                { id: 1_3_2, name: "中型", code: "23" },
                { id: 1_3_3, name: "小型", code: "24" }
              ]
            },
            {
              id: 1_4,
              name: "特定",
              children: [
                { id: 1_4_1, name: "大型", code: "13" },
                { id: 1_4_2, name: "中型", code: "25" },
                { id: 1_4_3, name: "小型", code: "26" }
              ]
            },
            {
              id: 1_5,
              name: "マイクロバス",
              code: "14"
            },
            {
              id: 1_6,
              name: "特殊車両",
              code: "27"
            }
          ]
        },
        {
          id: 2,
          name: "福祉車両（車椅子）",
          children: [
            { id: 2_1, name: "車椅子3台", code: "15" },
            { id: 2_2, name: "車椅子2台", code: "16" },
            { id: 2_3, name: "車椅子1台", code: "17" },
            { id: 2_4, name: "その他", code: "18" }
          ]
        },
        {
          id: 3,
          name: "福祉車両（ストレッチャー）",
          children: [
            { id: 3_1, name: "スト1台", code: "19" },
            { id: 3_2, name: "兼用", code: "20" }
          ]
        }
      ];
    },

    companiesSelect() {
      var companiesSelect = [];
      var prevCompanyName = "";
      this.companies.forEach(function(company) {
        if (prevCompanyName != company.company_name) {
          if (prevCompanyName) {
            companiesSelect.push({ divider: true });
          }
          companiesSelect.push({ header: company.company_name });
        }
        companiesSelect.push(company);
        prevCompanyName = company.company_name;
      });
      return companiesSelect;
    },

    equipments() {
      return this.equipmentsInternal(false);
    },

    selectedEquipments() {
      return this.equipmentsInternal(true);
    },

    equipmentHeaders() {
      let equipmentHeader = [
        {
          text: "事業区分",
          value: "equipment_cls"
        },
        {
          text: "分類",
          value: "equipment_kind"
        },
        {
          text: "資材ID",
          align: " d-none",
          value: "equipment_id"
        },
        {
          text: "資機材名",
          value: "equipment_name"
        },
        {
          text: "個数",
          value: "equipment_quantity"
        }
      ];
      if (!this.readOnly || !this.isWeb) {
        equipmentHeader.push({
          text: "操作",
          value: "actions",
          sortable: false
        });
      }
      return equipmentHeader;
    },

    companiesHeaders() {
      return [
        {
          text: "車両事業者ID",
          align: " d-none",
          value: "carop_id"
        },
        {
          text: "車両事業者区分",
          align: " d-none",
          value: "carop_cls"
        },
        {
          text: "代表電話番号",
          align: " d-none",
          value: "tel_no"
        },
        {
          text: "メールアドレス",
          align: " d-none",
          value: "mail_address"
        },
        {
          text: "車両事業者：営業所",
          value: "carop_name"
        },
        {
          text: "操作",
          value: "actions",
          sortable: false
        }
      ];
    },

    caropClses() {
      return [
        { value: "1", text: "バス協会" },
        { value: "2", text: "ハイヤー・タクシー協会" },
        { value: "3", text: "社会福祉協議会" },
        { value: "4", text: "その他" }
      ];
    },

    /**
     * フォームのプロパティ制御
     */
    formControlProps: () => {
      return function(counter = null) {
        return this.$formControlProps(this.readOnly, counter);
      };
    },

    isNew() {
      return !this.editFlag;
    },

    saveTitleText() {
      if (this.readOnly) {
        return "詳細";
      }
      return this.isNew ? "登録" : "編集";
    },

    saveBtnText() {
      return this.isNew ? "登録" : "更新";
    },

    saveTitleTextEquipment() {
      return this.isNewEquipment ? "登録" : "編集";
    },

    saveBtnTextEquipment() {
      return this.isNewEquipment ? "登録" : "更新";
    },

    saveTitleTextCompany() {
      if (this.readOnly) {
        return "詳細";
      }
      return this.isNewCompany ? "登録" : "編集";
    },

    saveBtnTextCompany() {
      return this.isNewCompany ? "登録" : "更新";
    },

    carOperatorButtonTitle() {
      return this.readOnly ? "一覧" : "管理";
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.overlay = true;
      const screen = this.$screenOperationAuthority(
        ScreenId.SF1701,
        ScreenId.SF1701
      );
      this.readOnly = screen.readOnly;
      this.isWeb = this.$route.params.type == "web";
      this.screenId = screen.screenId;
      this.screenTitle = screen.screenTitle;
      try {
        // 車両事業者一覧取得
        if (this.isWeb) {
          await this.$store.dispatch(
            "carOperator/loadCarOperator",
            this.screenId
          );
          this.companies = this.$store.state.carOperator.data.results;
          this.sortCompanies();
          this.companies.forEach(function(company) {
            var companyArray = company.carop_name.split("：");
            var company_name = companyArray[0];
            var sales_office_name = companyArray[1];
            company.company_name = company_name;
            company.sales_office_name = sales_office_name;
          });
        }

        // 資機材一覧取得
        await this.$store.dispatch("equipment/loadEquipment", this.screenId);
        this.equipmentList = this.$store.state.equipment.data.results;

        // 車両搭載対象資機材一覧取得
        await this.$store.dispatch(
          "carMountEquipment/loadCarMountEquipment",
          this.screenId
        );
        this.carMountEquipmentIdList = this.$store.state.carMountEquipment.data.results;
        this.carMountModifiedHash = this.$store.state.carMountEquipment.data.modified_hash;
        this.carMountEquipmentIdList.sort(function(a, b) {
          return a.equipment_id - b.equipment_id;
        });
        this.selection = [];
        var self = this;
        var equipmentList = this.equipmentsInternal(false);
        this.carMountEquipmentIdList.forEach(function(carMountEquipment) {
          equipmentList.forEach(function(cls) {
            cls.children.forEach(function(kind) {
              kind.children.forEach(function(equipment) {
                if (equipment.id === carMountEquipment.equipment_id) {
                  self.selection.push(equipment);
                  return;
                }
              });
            });
          });
        });

        // 新規か否か判定
        // id未設定なら新規作成
        if (this.$route.params.id) {
          this.editFlag = true;
          this.submitItem.car_id = this.$route.params.id;
          await this.$store
            .dispatch("car/loadCarDetail", {
              screenId: this.screenId,
              carId: this.submitItem.car_id
            })
            .then(() => {
              var detailData = this.$store.state.car.detailData;
              this.submitItem.carop_id = detailData.carop_id;
              this.submitItem.car_type = detailData.car_type;
              // 車両種別コードが特殊車両だった場合チェックボックスをオンにする
              this.specialCarResponse();
              if (this.submitItem.car_type == "27") {
                this.submitItem.car_number.special = detailData.car_number;
              } else {
                var carNumberArray = detailData.car_number.split(" ");
                this.submitItem.car_number.area = carNumberArray[0];
                this.submitItem.car_number.class = carNumberArray[1];
                this.submitItem.car_number.kind = carNumberArray[2];
                this.submitItem.car_number.number = carNumberArray[3];
              }
              this.submitItem.car_limit = detailData.car_limit;
              this.submitItem.modified_hash = detailData.modified_hash;
              for (var key in this.carStatusList) {
                var item = this.carStatusList[key];
                if (item.value == detailData.car_status) {
                  this.carStatus = item.text;
                }
              }
              this.mountEquipmentList = this.convertMountEquipmentList(
                detailData.equipments
              );
              this.selectCartype(this.submitItem.car_type);
            });
        } else {
          this.editFlag = false;
          this.mountEquipmentList = [];
          this.submitItem.car_number.area = "鹿児島";
        }
      } catch (error) {
        if (this.isWeb) {
          this.handleError(error, this.screenId, "aggregation-menu");
        } else {
          this.handleGetError(error);
          window.scrollTo(0, 0);
        }
      }
      this.overlay = false;
    },

    isNotEmpty(value) {
      return value !== undefined && value !== null && value !== "";
    },

    isEmpty(value) {
      return !this.isNotEmpty(value);
    },

    equipmentsInternal(isSelection) {
      var equipmentTree = [];
      var clsTree = [];
      var list = [];
      var clsList = [];

      if (isSelection) {
        var listPrev = JSON.parse(JSON.stringify(this.equipmentList));
        if (this.selection) {
          var self = this;
          listPrev.forEach(function(item) {
            self.selection.forEach(function(select) {
              if (item.equipment_id == select.id) {
                list.push(item);
                return;
              }
            });
          });
        }
      } else {
        list = JSON.parse(JSON.stringify(this.equipmentList));
      }

      list.forEach(function(equipment) {
        if (!clsList.includes(equipment.equipment_cls)) {
          clsList.push(equipment.equipment_cls);
        }
      });

      // 未登録の搭載資機材のみを抽出
      this.mountEquipmentList.forEach(function(equipment) {
        list = list.filter(function(item, index) {
          if (item.equipment_id == equipment.equipment_id) {
            list[index].locked = true;
          }
          return true;
        });
      });

      // ツリー構造を作成
      clsList.forEach(function(equipmentCls, index) {
        // 事業区分で資機材一覧をフィルタリング
        var filtered = list.filter(function(item) {
          return item.equipment_cls == equipmentCls;
        });

        // 事業区分単位のツリーを作成(childrenは事業区分でフィルタリングされた資機材一覧で、分類ではフィルタリングされていない)
        clsTree.push({
          id: "0_" + index + 1,
          name: equipmentCls,
          children: filtered
        });
      });

      clsTree.forEach(function(clsTreeItem) {
        var kindTree = [];
        var filteredList = [];
        var lockedKindCount = 0;

        clsTreeItem.children.forEach(function(child, index) {
          // すでに分類のフィルタリングをかけていれば、処理なし
          if (!filteredList.includes(child.equipment_kind)) {
            filteredList.push(child.equipment_kind);
            var filtered = clsTreeItem.children.filter(function(item) {
              return item.equipment_kind == child.equipment_kind;
            });

            // 資機材のId, Nameのみ抽出
            var temp = [];
            var lockedCount = 0;
            filtered.forEach(function(equipment) {
              if (equipment.locked) {
                lockedCount++;
              }
              temp.push({
                id: equipment.equipment_id,
                name: equipment.equipment_name,
                locked: equipment.locked ? true : false
              });
            });

            // 分類単位のツリーを作成
            var kindTreeLocked = temp.length == lockedCount ? true : false;
            if (kindTreeLocked) {
              lockedKindCount++;
            }
            kindTree.push({
              id: clsTreeItem.id + "_" + index + 1,
              name: child.equipment_kind,
              children: temp,
              locked: kindTreeLocked
            });
          }
        });

        // 資機材全体のツリーを作成
        equipmentTree.push({
          id: clsTreeItem.id,
          name: clsTreeItem.name,
          children: kindTree,
          locked: kindTree.length == lockedKindCount ? true : false
        });
      });
      return equipmentTree;
    },

    specialFlagResponse() {
      if (this.specialFlag == true) {
        this.registerItem.car_type = this.submitItem.car_type;
        this.submitItem.car_type = "27";
      } else {
        this.submitItem.car_type = this.registerItem.car_type;
      }
      this.selectCartype(this.submitItem.car_type);
    },

    specialCarResponse() {
      if (this.submitItem.car_type == "27") {
        this.specialFlag = true;
        this.registerItem.car_type = "";
      } else {
        this.specialFlag = false;
      }
    },

    confirm() {
      this.comfirmDialog = true;
    },

    saveConfirm() {
      if (
        JSON.stringify(this.carMountEquipmentIdList) !=
        JSON.stringify(this.getSelectedEquipmentIdList())
      ) {
        this.saveDialog = true;
      } else {
        this.selectionEquipment = false;
      }
    },

    getSelectedEquipmentIdList() {
      var selectedEquipmentIdList = [];
      this.selection.forEach(function(select) {
        selectedEquipmentIdList.push({
          equipment_id: select.id
        });
      });
      selectedEquipmentIdList.sort(function(a, b) {
        return a.equipment_id - b.equipment_id;
      });
      return selectedEquipmentIdList;
    },

    async saveSelectedEquipment() {
      this.clearMessage();
      this.overlay = true;
      this.processingFlag = true;
      var equipmentIdList = [];
      this.selection.forEach(function(select) {
        equipmentIdList.push(select.id);
      });
      try {
        // 車両搭載対象資機材一括登録API呼出
        await this.$store.dispatch("carMountEquipment/entryCarMountEquipment", {
          screenId: this.screenId,
          equipment_id_list: equipmentIdList,
          modified_hash: this.carMountModifiedHash
        });
        this.carMountModifiedHash = this.$store.state.carMountEquipment.registeredData.modified_hash;
        this.carMountEquipmentIdList = this.getSelectedEquipmentIdList();
      } catch (error) {
        this.handleCreateError(error);
        this.equipmentDialog = false;
        this.equipmentSelectDialog = false;
        window.scrollTo(0, 0);
      }
      this.selectionEquipment = false;
      this.selectEquipmentConfirmDialog = false;
      this.processingFlag = false;
      this.overlay = false;
    },

    checkSubmit() {
      let valid =
        this.isNotEmpty(this.submitItem.carop_id) &&
        this.isNotEmpty(this.submitItem.car_type) &&
        this.isNotEmpty(this.submitItem.car_limit);
      let carNumberValid =
        this.submitItem.car_type == "27"
          ? this.isNotEmpty(this.submitItem.car_number.special)
          : this.isNotEmpty(this.submitItem.car_number.area) &&
            this.checkZenkaku(this.submitItem.car_number.area) &&
            this.isNotEmpty(this.submitItem.car_number.class) &&
            this.checkAlphaNum(this.submitItem.car_number.class) &&
            this.isNotEmpty(this.submitItem.car_number.kind) &&
            this.checkHiraganaOrAlpha(this.submitItem.car_number.kind) &&
            this.isNotEmpty(this.submitItem.car_number.number);
      this.validationFlag = !(valid && carNumberValid);
    },

    async submit() {
      if (this.$refs.form.validate() === false) {
        return;
      }
      this.clearMessage();
      this.overlay = true;
      this.processingFlag = true;
      if (!this.editFlag) {
        try {
          // 管理車両登録API呼出
          await this.$store.dispatch("car/entryCar", {
            screenId: this.screenId,
            car: this.submitItem
          });
          this.$router.push("/car");
        } catch (error) {
          this.handleCreateError(error);
          window.scrollTo(0, 0);
        }
      } else {
        try {
          // 管理車両更新API呼出
          await this.$store.dispatch("car/updateCar", {
            screenId: this.screenId,
            car: this.submitItem
          });
          this.$router.push("/car");
        } catch (error) {
          this.handleUpdateError(error);
          window.scrollTo(0, 0);
        }
      }
      this.comfirmDialog = false;
      this.processingFlag = false;
      this.overlay = false;
    },

    close() {
      this.$router.push("/car");
    },

    checkEquipmentSubmit() {
      this.equipmentValidationFlag = !(
        this.isNotEmpty(this.equipmentItem.equipment_name) &&
        this.isNotEmpty(this.equipmentItem.equipment_quantity)
      );
    },

    async saveEquipment() {
      if (this.$refs.addEquipmentForm.validate() === false) {
        return;
      }
      this.clearMessage();
      this.overlay = true;
      this.processingFlag = true;
      if (this.isNewEquipment) {
        try {
          // 搭載資機材登録API呼出
          await this.$store.dispatch(
            "equipmentMountMan/entryEquipmentMountMan",
            {
              screenId: this.screenId,
              car_id: this.submitItem.car_id,
              equipment: this.equipmentItem
            }
          );
          this.equipmentItem.equipment_man_id = this.$store.state.equipmentMountMan.registeredData.equipment_man_id;
          this.equipmentItem.modified_hash = this.$store.state.equipmentMountMan.registeredData.modified_hash;
          this.mountEquipmentList.push(Object.assign({}, this.equipmentItem));
        } catch (error) {
          this.handleCreateError(error);
          window.scrollTo(0, 0);
        }
      } else {
        try {
          // 搭載資機材更新API呼出
          await this.$store.dispatch(
            "equipmentMountMan/updateEquipmentMountMan",
            { screenId: this.screenId, equipment: this.equipmentItem }
          );
          this.equipmentItem.equipment_man_id = this.$store.state.equipmentMountMan.registeredData.equipment_man_id;
          this.equipmentItem.modified_hash = this.$store.state.equipmentMountMan.registeredData.modified_hash;
          Object.assign(
            this.mountEquipmentList[this.editEquipmentIndex],
            this.equipmentItem
          );
        } catch (error) {
          this.handleUpdateError(error);
          window.scrollTo(0, 0);
        }
      }
      this.editEquipmentIndex = -1;
      this.equipmentDialog = false;
      this.equipmentConfirmDialog = false;
      this.equipmentItem = Object.assign({}, this.equipmentItemDefault);
      this.processingFlag = false;
      this.overlay = false;
    },

    addEquipment() {
      this.isNewEquipment = true;
      this.equipmentItem = Object.assign({}, this.equipmentItemDefault);
      this.checkEquipmentSubmit();
      if (this.$refs.addEquipmentForm) {
        this.$refs.addEquipmentForm.resetValidation();
      }
      this.equipmentDialog = true;
    },

    editEquipment(item) {
      this.isNewEquipment = false;
      this.editEquipmentIndex = this.mountEquipmentList.indexOf(item);
      this.equipmentItem = Object.assign({}, item);
      this.checkEquipmentSubmit();
      this.equipmentDialog = true;
    },

    deleteEquipmentConfirm(item) {
      this.deleteEquipmentDialog = true;
      this.deleteEquipmentName = item.equipment_name;
      this.deleteEquipmentIndex = this.mountEquipmentList.indexOf(item);
    },

    async deleteEquipment(index) {
      this.clearMessage();
      this.overlay = true;
      this.processingFlag = true;
      try {
        // 搭載資機材削除API呼出
        await this.$store.dispatch(
          "equipmentMountMan/deleteEquipmentMountMan",
          { screenId: this.screenId, equipment: this.mountEquipmentList[index] }
        );
        this.mountEquipmentList.splice(index, 1);
      } catch (error) {
        this.handleUpdateError(error);
        window.scrollTo(0, 0);
      }
      this.deleteEquipmentDialog = false;
      this.deleteEquipmentIndex = -1;
      this.processingFlag = false;
      this.overlay = false;
    },

    selectedCompany(data) {
      this.submitItem.carop_id = data.carop_id;
      this.selectCompanyClick = true;
    },

    checkCompanySubmit() {
      this.companyValidationFlag = !(
        this.isNotEmpty(this.companyItem.company_name) &&
        this.checkExceptColon(this.companyItem.company_name) &&
        (this.isEmpty(this.companyItem.sales_office_name) ||
          this.checkExceptColon(this.companyItem.sales_office_name)) &&
        this.isNotEmpty(this.companyItem.carop_cls) &&
        (this.isEmpty(this.companyItem.tel_no) ||
          this.checkTelNo(this.companyItem.tel_no)) &&
        (this.isEmpty(this.companyItem.mail_address) ||
          this.checkMailAddress(this.companyItem.mail_address))
      );
    },

    async saveCompany() {
      var sameCaropIdFlag = false;
      if (this.$refs.companyForm.validate() === false) {
        return;
      }
      this.clearMessage();
      this.overlay = true;
      this.processingFlag = true;
      if (this.isNewCompany) {
        // 車両事業者登録API呼出
        await this.$store
          .dispatch("carOperator/entryCarOperator", {
            screenId: this.screenId,
            company: this.companyItem
          })
          .then(() => {
            this.companyItem.carop_id = this.$store.state.carOperator.registeredData.carop_id;
            this.companyItem.modified_hash = this.$store.state.carOperator.registeredData.modified_hash;
            this.setCaropName(this.companyItem);
            this.companies.push(Object.assign({}, this.companyItem));
            this.sortCompanies();
            this.handleSuccess({
              data: {
                success: {
                  code: "MSGW27007",
                  message: {
                    value:
                      "車両事業者の新規登録後は、避難車両配車システム(DPND)にて住所・緯度経度等の情報をメンテナンスしてください。"
                  }
                }
              }
            });
            this.companyListDialog = false;
          })
          .catch(error => {
            this.handleCreateError(error);
            this.companyListDialog = false;
          })
          .finally(() => {
            window.scrollTo(0, 0);
          });
      } else {
        // 車両事業者更新API呼出
        await this.$store
          .dispatch("carOperator/updateCarOperator", {
            screenId: this.screenId,
            company: this.companyItem
          })
          .then(() => {
            // 同じ車両事業者を更新した場合に車両事業者名が更新されるための処理1
            if (this.submitItem.carop_id == this.companyItem.carop_id) {
              this.submitItem.carop_id = -1;
              sameCaropIdFlag = true;
            }
            this.companyItem.modified_hash = this.$store.state.carOperator.registeredData.modified_hash;
            this.setCaropName(this.companyItem);
            Object.assign(
              this.companies[this.editCompanyIndex],
              this.companyItem
            );
            this.sortCompanies();
          })
          .catch(error => {
            this.handleUpdateError(error);
            this.companyListDialog = false;
            window.scrollTo(0, 0);
          });
      }
      // 同じ車両事業者を更新した場合に車両事業者名が更新されるための処理2
      if (sameCaropIdFlag) {
        this.submitItem.carop_id = this.companyItem.carop_id;
      }
      this.companyItem = Object.assign({}, this.companyItemDefalut);
      this.editCompanyIndex = -1;
      this.companyDialog = false;
      this.companyConfirmDialog = false;
      this.processingFlag = false;
      this.overlay = false;
    },

    addCompany() {
      this.isNewCompany = true;
      this.editCompanyIndex = -1;
      this.companyItem = Object.assign({}, this.companyItemDefalut);
      this.checkCompanySubmit();
      if (this.$refs.companyForm) {
        this.$refs.companyForm.resetValidation();
      }
      this.companyDialog = true;
    },

    editCompanyItem(item) {
      this.isNewCompany = false;
      this.editCompanyIndex = this.companies.indexOf(item);
      this.companyItem = Object.assign({}, item);
      this.checkCompanySubmit();
      this.companyDialog = true;
    },

    deleteCompanyConfirm(item) {
      this.deleteCompanyDialog = true;
      this.deleteCompanyName = item.carop_name;
      this.deleteCompanyIndex = this.companies.indexOf(item);
    },

    sortCompanies() {
      this.companies.sort(function(a, b) {
        if (a.carop_name > b.carop_name) {
          return 1;
        } else {
          return -1;
        }
      });
    },

    setCaropName(item) {
      item.carop_name = item.company_name;
      if (item.sales_office_name) {
        item.carop_name += "：" + item.sales_office_name;
      }
    },

    async deleteCompany(index) {
      this.clearMessage();
      this.overlay = true;
      this.processingFlag = true;
      // 車両事業者削除API呼出
      await this.$store
        .dispatch("carOperator/deleteCarOperator", {
          screenId: this.screenId,
          company: this.companies[index]
        })
        .then(() => {
          this.companies.splice(index, 1);
        })
        .catch(error => {
          this.handleUpdateError(error);
          this.companyListDialog = false;
          window.scrollTo(0, 0);
        });
      this.deleteCompanyDialog = false;
      this.deleteCompanyIndex = -1;
      this.processingFlag = false;
      this.overlay = false;
    },

    selectCartype(code) {
      let cartypeCode = "";
      let cartype = "";
      let carkind = "";
      let carsize = "";

      //ツリーの第一階層を検索
      for (const node of this.cartypeTree) {
        //ノードが子を持つならば下の階層を検索
        if (node.children != undefined) {
          for (const child of node.children) {
            //孫があるなら下の階層を検索
            if (child.children != undefined) {
              for (const childchild of child.children) {
                if (code == childchild.code) {
                  cartypeCode = childchild.code;
                  cartype = node.name;
                  carkind = child.name;
                  carsize = childchild.name;
                  break;
                }
              }
              //孫が無ければアイテムと一致しているかチェック
            } else {
              if (code == child.code) {
                cartypeCode = child.code;
                cartype = node.name;
                carkind = child.name;
                break;
              }
            }
          }
          //ノードが子を持たないのであればアイテムと一致しているかチェック
        } else {
          if (code == node.code) {
            cartypeCode = node.code;
            cartype = node.name;
            break;
          }
        }
      }

      this.submitItem.car_type = cartypeCode;

      let str = cartype;
      if (carkind) {
        str = str + "／" + carkind;
      }
      if (carsize) {
        str = str + "／" + carsize;
      }
      this.submitItem.car_type_disp = str;

      this.cartypeSelectDialog = false;

      this.checkSubmit();
    },

    carTypeClear() {
      this.registerItem.car_type = "";

      this.submitItem.car_type = "";
      this.submitItem.car_type_disp = "";

      this.specialFlag = false;
    },

    selectEquipment(item) {
      let itemParent = this.findTreeItemParent(item);

      this.equipmentItem.equipment_id = item.id;
      this.equipmentItem.equipment_name = item.name;
      this.equipmentItem.equipment_kind = itemParent[0];
      this.equipmentItem.equipment_cls = itemParent[1];

      this.checkEquipmentSubmit();
      this.equipmentSelectDialog = false;
    },

    findTreeItemParent(selected) {
      for (const item of this.equipments) {
        // Test current object
        for (const child of item.children) {
          for (const childchild of child.children) {
            if (
              selected.name == childchild.name &&
              selected.id == childchild.id
            ) {
              return [child.name, item.name];
            }
          }
        }
      }
    },

    convertMountEquipmentList(sourceMountEquipments) {
      var equipmentList = this.equipmentList;
      var mountEquipmentList = [];
      if (sourceMountEquipments.length) {
        sourceMountEquipments.forEach(function(sourceMountEquipment) {
          var temp = equipmentList.filter(function(item) {
            return item.equipment_id == sourceMountEquipment.equipment_id;
          });
          // 資機材IDで一意に特定されているため、indexが0を取得
          if (temp.length > 0) {
            var mountEquipment = JSON.parse(JSON.stringify(temp[0]));
            mountEquipment.equipment_man_id =
              sourceMountEquipment.equipment_man_id;
            mountEquipment.equipment_quantity =
              sourceMountEquipment.equipment_quantity;
            mountEquipment.modified_hash = sourceMountEquipment.modified_hash;
            mountEquipmentList.push(mountEquipment);
          }
        });
      }
      return mountEquipmentList;
    },

    checkZenkaku(value) {
      const pattern = /^[^!-~｡-ﾟ]+$/;
      return pattern.test(value);
    },
    checkAlphaNum(value) {
      const pattern = /^[A-Za-z0-9]+$/;
      return pattern.test(value);
    },
    checkHiraganaOrAlpha(value) {
      const hiraganaPattern = /^[ぁ-んー]+$/;
      const alphaPattern = /^[A-Za-z]+$/;
      return hiraganaPattern.test(value) || alphaPattern.test(value);
    },
    checkTelNo(value) {
      const pattern = /^[0-9()-]*$/;
      return pattern.test(value);
    },
    checkMailAddress(value) {
      const pattern = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{2,}$/;
      return pattern.test(value);
    },
    checkExceptColon(value) {
      return !value.includes("：");
    }
  }
};
</script>
